<template>
  <div class="modal-container" @click.stop :style="{ width: width }">
    <div v-if="showSpinner" class="spinner-overlay">
      <IonSpinner name="crescent" />
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { IonSpinner } from '@ionic/vue';

interface Props {
  width?: string;
  showSpinner?: boolean;
}

withDefaults(defineProps<Props>(), {
  width: '400px',
  showSpinner: false,
});
</script>

<style scoped>
.modal-container {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  background-color: var(--ion-input-background);
  border-radius: 3vmin;
  /* border: 2px solid var(--ion-input-border-color); */
  /* position: relative; */
}

.spinner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  border-radius: inherit;
}

.content-disabled {
  pointer-events: none;
  opacity: 0.6;
}

.spinner-overlay ion-spinner {
  --color: var(--ion-color-primary);
  transform: scale(1.5);
}
</style>
